import { API_URL, PRICE_SCHEME_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IUpdateOptionGroupRequestBody } from './types';

const GENERIC_ERROR_MESSAGE = 'Something went wrong whilst updating the option group';

export const updateOptionGroup = async (
  optionGroupId: string,
  requestBody: IUpdateOptionGroupRequestBody,
  priceSchemeId: string,
): Promise<Response> => {
  const url = `${API_URL}/option-groups/${optionGroupId}`;

  const res = await fetch(url, {
    method: 'PATCH',
    body: JSON.stringify(requestBody),
    headers: {
      [PRICE_SCHEME_HEADER]: priceSchemeId,
    },
  });

  if (!res.ok) {
    let errorBody: { message?: string } | null;
    try {
      errorBody = await res.json();
    } catch {
      errorBody = null;
    }
    throw new Error(errorBody?.message || GENERIC_ERROR_MESSAGE);
  }

  return res;
};
